/**
 * Application Bootstrap
 *
 * Wires the auth store into the shared api client, then seeds stores from the
 * server-injected bootstrap island (W4 D3) so the authenticated UI can render
 * without the /auth/me + /auth/modules round-trips. Injection-preferred: when
 * the island is present we seed synchronously; the React-Query fetches still
 * run as background revalidation + the fallback when the island is absent.
 */
import { configureApiAuth } from '@marine/api-client/api';
import { tenantAuthStore } from '@/modules/tenant/state/tenantAuth';
import { usePreferencesStore } from '@/state/preferences';
import type { PreferencesTree } from '@/types/preferences';
import type { Employee, Tenant } from '@/modules/tenant/state/tenantAuth';
import { readBootstrap } from '@/lib/readBootstrap';

configureApiAuth(() => {
  const s = tenantAuthStore.getState();
  return { logout: s.logout };
});

export const bootstrap = async (): Promise<void> => {
  const data = readBootstrap();
  if (!data) return;
  try {
    if (data.tenant) tenantAuthStore.getState().setTenant(data.tenant as unknown as Tenant);
    if (data.auth) {
      tenantAuthStore.getState().setEmployee(data.auth.employee as unknown as Employee);
      usePreferencesStore.getState().setAll((data.auth.preferences ?? {}) as PreferencesTree);
    }
  } catch {
    // Island seeding failed — the app falls back to the /auth/me + /auth/modules fetches.
  }
};
